import { OAuth2AuthCodePKCE } from '@bity/oauth2-auth-code-pkce'
import { MessageType, PartialMessage } from '@protobuf-ts/runtime'
import { ConflictMonitorRef, ConflictMonitorView } from 'pbts/c1/api/accessconflict/v1/accessconflict'
import {
    AccessViolationCountRefreshRef,
    AccessViolationRef,
} from 'pbts/c1/api/accessconflict/v1/accessviolation'
import { AppEntitlementMonitorBindingRef, AppEntitlementMonitorBindingView } from 'pbts/c1/api/accessconflict/v1/app_entitlement_monitor_binding'
import {
    AccessReview,
    AccessReviewConnectorSourceRef,
    AccessReviewRef,
    AccessReviewReportRef,
    AccessReviewSelectionRef,
    AccessReviewTemplate,
    AccessReviewTemplateOwnerRef,
    AccessReviewTemplateRef,
    AccessReviewTemplateResourceRollupRef,
    AccessReviewTemplateResourceTypeRollupRef,
    AccessReviewTemplateServiceSearchOwnerView,
} from 'pbts/c1/api/accessreview/v1/accessreview'
import { PendingSummaryRef } from 'pbts/c1/api/accessreview/v1/accessreview_pending'
import {
    AccessReviewAppNavRollupRef,
    AccessReviewAppUserDetailRowSearchRef,
    AccessReviewSearchServiceEntitlementRollupRef,
    AccessReviewSearchServiceUserRollupRef,
    AccessReviewUserNavRollupRef,
    AppRollup,
    ResourceRollupRef,
    ResourceTypeRollupRef,
} from 'pbts/c1/api/accessreview/v1/accessreview_search'
import { Action, ActionRef } from 'pbts/c1/api/action/v1/action'
import { App, AppRef } from 'pbts/c1/api/app/v1/app'
import { AppAccessRequestDefaultsRef } from 'pbts/c1/api/app/v1/app_access_requests_defaults'
import {
    AncestralBindingRef,
    AppEntitlement, AppEntitlementAutomationRef,
} from 'pbts/c1/api/app/v1/app_entitlement'
import { AppEntitlementProxy, SearchAppEntitlementProxyBindingsRef } from 'pbts/c1/api/app/v1/app_entitlement_proxy'
import { AppManagedStateBindingRef, AppManagedStateBindingView } from 'pbts/c1/api/app/v1/app_managed'
import { AppOwnerRef } from 'pbts/c1/api/app/v1/app_owner'
import { AppEntitlementRef, AppEntitlementUserBindingRef } from 'pbts/c1/api/app/v1/app_refs'
import {
    AppResource, AppResourceRef, AppResourceType, AppResourceTypeRef, HighRiskRolesAndCountStruct,
    HighRiskRolesAndGrantsStruct,
} from 'pbts/c1/api/app/v1/app_resource'
import { AppResourceOwnerRef, AppResourceOwnerRefreshRef } from 'pbts/c1/api/app/v1/app_resource_owner'
import { AppUser, AppUserCredential, AppUserCredentialRef, AppUserRef } from 'pbts/c1/api/app/v1/app_user'
import { Connector, ConnectorRef, ConnectorSyncLifecycleRef, ConnectorView } from 'pbts/c1/api/app/v1/connector'
import { AppIconRef } from 'pbts/c1/api/assets/v1/app_icons'
import { ProfileTypeIconRef } from 'pbts/c1/api/assets/v1/profile_type_icons'
import { UserAvatarRef } from 'pbts/c1/api/assets/v1/user_avatars'
import { AutomationTemplateRef } from 'pbts/c1/api/automations/v1/automations'
import { AutomationExecutionRef, AutomationExecutionStepRef } from 'pbts/c1/api/automations/v1/automations_executions'
import { BulkActionRef } from 'pbts/c1/api/bulkaction/v1/bulkaction'
import { UIConversationRef, UIMessageRef } from 'pbts/c1/api/conversations/v1/conversations'
import { DirectoryRef, DirectoryView } from 'pbts/c1/api/directory/v1/directory'
import { ExportDataActionRef } from 'pbts/c1/api/exportdata/v1/exportdata'
import { ExternalTicketProvisionerConfig, ExternalTicketProvisionerConfigRef } from 'pbts/c1/api/external_tickets/v1/external_tickets'
import { FormSchema, FormSchemaRef } from 'pbts/c1/api/form/v1/form'
import { FunctionCommitRef, FunctionInvocationRef, FunctionLogRef, FunctionRef } from 'pbts/c1/api/functions/v1/functions'
import { PersonalClient, PersonalClientRef } from 'pbts/c1/api/iam/v1/clients'
import { ExternalClientGrantRef } from 'pbts/c1/api/iam/v1/external_clients'
import { ConnectorInstallation } from 'pbts/c1/api/integration/connector/v1/catalog'
import { DataSourceInstallation, DataSourceInstallationRef } from 'pbts/c1/api/integration/datasource/v1/catalog'
import { ServiceDeskIntegrationRef } from 'pbts/c1/api/integration/external_ticketing/v1/external_ticketing'
import { MSTeamsDirectoryBindingRef } from 'pbts/c1/api/ms_teams/v1/ms_teams'
import { OffboardingTrackerRef, OffboardingTrackerView } from 'pbts/c1/api/offboarding/v1/offboarding'
import { PasswordPolicyRef } from 'pbts/c1/api/password_push/v1/password_policy_search'
import { PasswordPushFlowRef } from 'pbts/c1/api/password_push/v1/password_push_flow_search'
import { PasswordPushFlowTargetBindingRef } from 'pbts/c1/api/password_push/v1/password_push_flow_target_binding'
import { PasswordPushFlowVisibilityBindingRef } from 'pbts/c1/api/password_push/v1/password_push_flow_visibility_binding'
import { PasswordPushInvocationRef, PasswordPushInvocationTargetStateRef } from 'pbts/c1/api/password_push/v1/password_push_invocation_search'
import { Policy, PolicyRef } from 'pbts/c1/api/policy/v1/policy'
import { ProfileTypeRef } from 'pbts/c1/api/profiletype/v1/profiletype'
import { UserAttributePushConfigurationRef } from 'pbts/c1/api/push_rules/v1/push_rules'
import { UserAttributePushConfigurationRollup } from 'pbts/c1/api/push_rules/v1/push_rules_search'
import { PushSetRef } from 'pbts/c1/api/pushset/v1/pushset'
import { RequestSchemaRef } from 'pbts/c1/api/request_schema/v1/request_schema'
import {
    AppEntitlementWithRequestCatalogs,
    AppEntitlementWithRequestCatalogsRef,
    BundleAppsWithCount,
    RequestCatalog,
    RequestCatalogAppEntitlementBindingRef,
    RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef,
    RequestCatalogSearchServiceSearchEntitlementsPerAppRef,
    RequestCatalogUserEntitlementPerApp,
} from 'pbts/c1/api/requestcatalog/v1/requestcatalog'
import { BundleAutomationRef, RequestCatalogRef } from 'pbts/c1/api/requestcatalog/v1/requestcatalogmanagement'
import { ServicePrincipalRef } from 'pbts/c1/api/service_principal/v1/service_principal'
import { NotificationConfig, SessionSettings } from 'pbts/c1/api/settings/v1/admin_settings'
import { BrandingSettingsRef } from 'pbts/c1/api/settings/v1/branding'
import { MCPSettingsRef } from 'pbts/c1/api/settings/v1/mcp'
import { StepUpProviderRef } from 'pbts/c1/api/stepup/v1/stepup'
import { Exporter, ExporterRef } from 'pbts/c1/api/systemlog/v1/export'
import { BulkActionItemRef, TaskBulkActionRef } from 'pbts/c1/api/task/v1/actions'
import { TaskAuditViewRef } from 'pbts/c1/api/task/v1/audit'
import { GrantOrRevokeTaskRef, TaskCountRefreshRef, TaskRef } from 'pbts/c1/api/task/v1/task'
import { UsageResourceRef } from 'pbts/c1/api/usage_event/v1/usage_event'
import { UserAttributeMappingRef } from 'pbts/c1/api/user/v1/attribute'
import { AgentRef, AgentView, User, UserRef } from 'pbts/c1/api/user/v1/user'
import { AppVaultBinding, AppVaultBindingRef, Vault, VaultRef } from 'pbts/c1/api/vault/v1/vault'
import {
    Webhook,
    WebhookInstance, WebhookInstanceRef, WebhookRef,
} from 'pbts/c1/api/webhooks/v1/webhooks'
import {
    ChangedRef,
    ChangedRefEventType,
} from 'pbts/c1/api/websocketnotify/v1/websocketnotify'
import { WorkloadFederationProviderRef, WorkloadFederationTrustRef } from 'pbts/c1/api/workload_federation/v1/workload_federation'
import { Any } from 'pbts/google/protobuf/any'
import { Timestamp } from 'pbts/google/protobuf/timestamp'
import { RequestCatalogUserEntitlementPerAppValue } from 'redux_toolkit/browse-access'
import { AncestorWithDescendants } from 'redux_toolkit/entitlements'
import { AppValue } from './actions/apps'
import { DirectoryValue } from './actions/directory'
import { setGetAccessTokenProvider } from './ws/auth'
import { TOPIC_NOTIFY_CHANGED_RAW } from './ws/constants'
import { getWsHub } from './ws/hub'

const processEventsDelay = 5 * 100

export type AllowedRefs =
    | UserRef
    | UserAvatarRef
    | AppRef
    | AppIconRef
    | AppEntitlementRef
    | AppEntitlementAutomationRef
    | TaskRef
    | GrantOrRevokeTaskRef
    | ResourceRollupRef
    | ResourceTypeRollupRef
    | AccessReviewTemplateResourceRollupRef
    | AccessReviewTemplateResourceTypeRollupRef
    | RequestCatalogRef
    | AppUserRef
    | AccessReviewAppUserDetailRowSearchRef
    | AccessReviewUserNavRollupRef
    | AccessReviewSearchServiceUserRollupRef
    | AccessReviewSearchServiceEntitlementRollupRef
    | PersonalClientRef
    | ExternalClientGrantRef
    | PolicyRef
    | AccessReviewReportRef
    | AccessReviewSelectionRef
    | HighRiskRolesAndCountStruct
    | HighRiskRolesAndGrantsStruct
    | AppEntitlementProxy
    | AppResourceRef
    | AppResourceTypeRef
    | SearchAppEntitlementProxyBindingsRef
    | TaskBulkActionRef
    | BulkActionItemRef
    | ExporterRef
    | WebhookRef
    | WebhookInstanceRef
    | AccessViolationRef
    | RequestCatalogAppEntitlementBindingRef
    | ExportDataActionRef
    | AppResourceOwnerRefreshRef
    | AutomationTemplateRef
    | AutomationExecutionRef
    | AutomationExecutionStepRef
    | AppResourceOwnerRef
    | ConnectorSyncLifecycleRef
    | AccessReviewConnectorSourceRef
    | AccessReviewRef
    | AccessReviewTemplateRef
    | BulkActionRef
    | AccessViolationCountRefreshRef
    | ServiceDeskIntegrationRef
    | BundleAutomationRef
    | DataSourceInstallationRef
    | ExternalTicketProvisionerConfigRef
    | AppAccessRequestDefaultsRef
    | AppOwnerRef
    | AppEntitlementUserBindingRef
    | AppManagedStateBindingRef
    | MCPSettingsRef
    | TaskAuditViewRef
    | AppUserCredentialRef
    | StepUpProviderRef
    | TaskCountRefreshRef
    | AgentRef
    | UIConversationRef
    | UIMessageRef
    | RequestSchemaRef
    | FormSchemaRef
    | ProfileTypeRef
    | ProfileTypeIconRef
    | DirectoryRef
    | FunctionRef
    | FunctionCommitRef
    | FunctionInvocationRef
    | UsageResourceRef
    | VaultRef
    | AppVaultBindingRef
    | AncestralBindingRef
    | AppEntitlementMonitorBindingRef
    | AppEntitlementWithRequestCatalogsRef
    | ConflictMonitorRef
    | OffboardingTrackerRef
    | ConnectorRef
    | AccessReviewTemplateOwnerRef
    | PendingSummaryRef
    | AccessReviewAppNavRollupRef
    | RequestCatalogSearchServiceSearchEntitlementsPerAppRef
    | RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef
    | SessionSettings
    | UserAttributeMappingRef
    | PasswordPolicyRef
    | PasswordPushFlowRef
    | PasswordPushFlowVisibilityBindingRef
    | PasswordPushFlowTargetBindingRef
    | PasswordPushInvocationRef
    | PasswordPushInvocationTargetStateRef
    | PushSetRef
    | BrandingSettingsRef
    | ActionRef
    | MSTeamsDirectoryBindingRef
    | NotificationConfig
    | UserAttributePushConfigurationRef
    | ServicePrincipalRef
    | WorkloadFederationProviderRef
    | WorkloadFederationTrustRef

// Mapping for standard ref type handlers
const standardRefHandlers = {
    [UserRef.typeName]: UserRef,
    [UserAvatarRef.typeName]: UserAvatarRef,
    [AppRef.typeName]: AppRef,
    [AppIconRef.typeName]: AppIconRef,
    [ProfileTypeIconRef.typeName]: ProfileTypeIconRef,
    [AppEntitlementRef.typeName]: AppEntitlementRef,
    [AppEntitlementAutomationRef.typeName]: AppEntitlementAutomationRef,
    [TaskRef.typeName]: TaskRef,
    [GrantOrRevokeTaskRef.typeName]: GrantOrRevokeTaskRef,
    [ResourceRollupRef.typeName]: ResourceRollupRef,
    [ResourceTypeRollupRef.typeName]: ResourceTypeRollupRef,
    [AccessReviewTemplateResourceRollupRef.typeName]: AccessReviewTemplateResourceRollupRef,
    [AccessReviewTemplateResourceTypeRollupRef.typeName]: AccessReviewTemplateResourceTypeRollupRef,
    [RequestCatalogRef.typeName]: RequestCatalogRef,
    [AppUserRef.typeName]: AppUserRef,
    [AccessReviewAppUserDetailRowSearchRef.typeName]: AccessReviewAppUserDetailRowSearchRef,
    [AccessReviewUserNavRollupRef.typeName]: AccessReviewUserNavRollupRef,
    [AccessReviewSearchServiceUserRollupRef.typeName]: AccessReviewSearchServiceUserRollupRef,
    [AccessReviewSearchServiceEntitlementRollupRef.typeName]: AccessReviewSearchServiceEntitlementRollupRef,
    [BrandingSettingsRef.typeName]: BrandingSettingsRef,
    [PersonalClientRef.typeName]: PersonalClientRef,
    [ExternalClientGrantRef.typeName]: ExternalClientGrantRef,
    [PolicyRef.typeName]: PolicyRef,
    [AccessReviewReportRef.typeName]: AccessReviewReportRef,
    [AccessReviewSelectionRef.typeName]: AccessReviewSelectionRef,
    [HighRiskRolesAndCountStruct.typeName]: HighRiskRolesAndCountStruct,
    [HighRiskRolesAndGrantsStruct.typeName]: HighRiskRolesAndGrantsStruct,
    [AppEntitlementProxy.typeName]: AppEntitlementProxy,
    [AppResourceRef.typeName]: AppResourceRef,
    [AppResourceTypeRef.typeName]: AppResourceTypeRef,
    [SearchAppEntitlementProxyBindingsRef.typeName]: SearchAppEntitlementProxyBindingsRef,
    [TaskBulkActionRef.typeName]: TaskBulkActionRef,
    [ExporterRef.typeName]: ExporterRef,
    [WebhookRef.typeName]: WebhookRef,
    [WebhookInstanceRef.typeName]: WebhookInstanceRef,
    [AccessViolationRef.typeName]: AccessViolationRef,
    [RequestCatalogAppEntitlementBindingRef.typeName]: RequestCatalogAppEntitlementBindingRef,
    [ExportDataActionRef.typeName]: ExportDataActionRef,
    [UsageResourceRef.typeName]: UsageResourceRef,
    [TaskCountRefreshRef.typeName]: TaskCountRefreshRef,
    [AppResourceOwnerRefreshRef.typeName]: AppResourceOwnerRefreshRef,
    [AppAccessRequestDefaultsRef.typeName]: AppAccessRequestDefaultsRef,
    [AccessViolationCountRefreshRef.typeName]: AccessViolationCountRefreshRef,
    [ServiceDeskIntegrationRef.typeName]: ServiceDeskIntegrationRef,
    [BundleAutomationRef.typeName]: BundleAutomationRef,
    [DataSourceInstallationRef.typeName]: DataSourceInstallationRef,
    [ExternalTicketProvisionerConfigRef.typeName]: ExternalTicketProvisionerConfigRef,
    [AccessReviewTemplateRef.typeName]: AccessReviewTemplateRef,
    [AppOwnerRef.typeName]: AppOwnerRef,
    [AppResourceOwnerRef.typeName]: AppResourceOwnerRef,
    [AccessReviewRef.typeName]: AccessReviewRef,
    [AppManagedStateBindingRef.typeName]: AppManagedStateBindingRef,
    [AppEntitlementUserBindingRef.typeName]: AppEntitlementUserBindingRef,
    [BulkActionRef.typeName]: BulkActionRef,
    [ConnectorSyncLifecycleRef.typeName]: ConnectorSyncLifecycleRef,
    [AccessReviewConnectorSourceRef.typeName]: AccessReviewConnectorSourceRef,
    [VaultRef.typeName]: VaultRef,
    [AppVaultBindingRef.typeName]: AppVaultBindingRef,
    [AutomationTemplateRef.typeName]: AutomationTemplateRef,
    [AppUserCredentialRef.typeName]: AppUserCredentialRef,
    [StepUpProviderRef.typeName]: StepUpProviderRef,
    [AutomationExecutionRef.typeName]: AutomationExecutionRef,
    [AutomationExecutionStepRef.typeName]: AutomationExecutionStepRef,
    [TaskAuditViewRef.typeName]: TaskAuditViewRef,
    [MCPSettingsRef.typeName]: MCPSettingsRef,
    [AgentRef.typeName]: AgentRef,
    [UIConversationRef.typeName]: UIConversationRef,
    [UIMessageRef.typeName]: UIMessageRef,
    [RequestSchemaRef.typeName]: RequestSchemaRef,
    [FormSchemaRef.typeName]: FormSchemaRef,
    [ProfileTypeRef.typeName]: ProfileTypeRef,
    [DirectoryRef.typeName]: DirectoryRef,
    [FunctionRef.typeName]: FunctionRef,
    [FunctionCommitRef.typeName]: FunctionCommitRef,
    [FunctionInvocationRef.typeName]: FunctionInvocationRef,
    [FunctionLogRef.typeName]: FunctionLogRef,
    [AccessReviewAppNavRollupRef.typeName]: AccessReviewAppNavRollupRef,
    [SessionSettings.typeName]: SessionSettings,
    [NotificationConfig.typeName]: NotificationConfig,
    [AncestralBindingRef.typeName]: AncestralBindingRef,
    [ConflictMonitorRef.typeName]: ConflictMonitorRef,
    [AppEntitlementMonitorBindingRef.typeName]: AppEntitlementMonitorBindingRef,
    [RequestCatalogSearchServiceSearchEntitlementsPerAppRef.typeName]: RequestCatalogSearchServiceSearchEntitlementsPerAppRef,
    [RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef.typeName]: RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef,
    [OffboardingTrackerRef.typeName]: OffboardingTrackerRef,
    [ConnectorRef.typeName]: ConnectorRef,
    [AppEntitlementWithRequestCatalogsRef.typeName]: AppEntitlementWithRequestCatalogsRef,
    [AccessReviewTemplateOwnerRef.typeName]: AccessReviewTemplateOwnerRef,
    [PendingSummaryRef.typeName]: PendingSummaryRef,
    [BulkActionItemRef.typeName]: BulkActionItemRef,
    [UserAttributeMappingRef.typeName]: UserAttributeMappingRef,
    [PasswordPolicyRef.typeName]: PasswordPolicyRef,
    [PasswordPushFlowRef.typeName]: PasswordPushFlowRef,
    [PasswordPushFlowVisibilityBindingRef.typeName]: PasswordPushFlowVisibilityBindingRef,
    [PasswordPushFlowTargetBindingRef.typeName]: PasswordPushFlowTargetBindingRef,
    [PasswordPushInvocationRef.typeName]: PasswordPushInvocationRef,
    [PasswordPushInvocationTargetStateRef.typeName]: PasswordPushInvocationTargetStateRef,
    [PushSetRef.typeName]: PushSetRef,
    [MSTeamsDirectoryBindingRef.typeName]: MSTeamsDirectoryBindingRef,
    [ActionRef.typeName]: ActionRef,
    [UserAttributePushConfigurationRef.typeName]: UserAttributePushConfigurationRef,
    [ServicePrincipalRef.typeName]: ServicePrincipalRef,
    [WorkloadFederationProviderRef.typeName]: WorkloadFederationProviderRef,
    [WorkloadFederationTrustRef.typeName]: WorkloadFederationTrustRef,
} as const

// Define the mapping tuples first
const knownMessageTypeToRefTuples: Array<[unknown, AllowedRefs]> = [
    [App, AppRef],
    [User, UserRef],
    [AppEntitlementProxy, SearchAppEntitlementProxyBindingsRef],
    [AppUser, AppUserRef],
    [AppResource, AppResourceRef],
    [AppResourceType, AppResourceTypeRef],
    [Connector, ConnectorRef],
    [ExternalTicketProvisionerConfig, ExternalTicketProvisionerConfigRef],
    [AppEntitlement, AppEntitlementRef],
    [Webhook, WebhookRef],
    [WebhookInstance, WebhookInstanceRef],
    [AccessReviewTemplate, AccessReviewTemplateRef],
    [DataSourceInstallation, DataSourceInstallationRef],
    [Exporter, ExporterRef],
    [AccessReview, AccessReviewRef],
    [AccessReviewTemplateServiceSearchOwnerView, AccessReviewTemplateOwnerRef],
    [AppManagedStateBindingView, AppManagedStateBindingRef],
    [PersonalClient, PersonalClientRef],
    [Vault, VaultRef],
    [AppVaultBinding, AppVaultBindingRef],
    [AppUserCredential, AppUserCredentialRef],
    [RequestCatalog, RequestCatalogRef],
    [FormSchema, FormSchemaRef],
    [AutomationTemplateRef, AutomationTemplateRef],
    [StepUpProviderRef, StepUpProviderRef],
    [ConnectorInstallation, ConnectorInstallation], // Special case: same type for both
    [AgentView, AgentRef],
    [Policy, PolicyRef],
    [UIConversationRef, UIConversationRef],
    [UIMessageRef, UIMessageRef],
    [ProfileTypeRef, ProfileTypeRef],
    [DirectoryView, DirectoryRef],
    [ProfileTypeIconRef, ProfileTypeIconRef],
    [Action, ActionRef],
    // NOTE: Websocket notifies do not need this. Just add to the map above.
] as const

// Additional message types that don't have mappings but were in the original KnownMessageTypes
type AdditionalMessageTypes =
    | MessageType<AppValue>
    | MessageType<RequestCatalogUserEntitlementPerApp>

// Generate types from the tuples
export type KnownMessageTypes = (typeof knownMessageTypeToRefTuples)[number][0] | AdditionalMessageTypes
export type KnownRefs = (typeof knownMessageTypeToRefTuples)[number][1]

// Create the mapping from the tuples
const knownMessageTypeToRefMapping = new Map<KnownMessageTypes, KnownRefs>(knownMessageTypeToRefTuples)

export const protoToRef = (p: KnownMessageTypes): KnownRefs | undefined => {
    return knownMessageTypeToRefMapping.get(p)
}

export const shouldProcess = (
    cachedTime?: Timestamp,
    updatedTime?: Timestamp,
): boolean => {
    if (!cachedTime || !updatedTime) {
        return true
    }

    const timeInCache = cachedTime.seconds * 1000 + cachedTime.nanos / 1000000
    const newTime = updatedTime.seconds * 1000 + updatedTime.nanos / 1000000
    return newTime > timeInCache
}

export type OnNotifyEventType = (
    ref: AllowedRefs,
    eventType: ChangedRefEventType,
    lastUpdatedAt: Timestamp | undefined
) => void

export const getRefString = (ref: AllowedRefs): string => {
    return Object.entries(ref)
        .map((e) => `${e[0]}:${e[1]}`)
        .join('|')
}

export const decodeRefString = (refString: string): AllowedRefs => {
    const ref = {}
    refString.split('|').forEach((e) => {
        const [key, value] = e.split(':')
        ref[key] = value
    })
    return ref as AllowedRefs
}

const hasAppId = (data: { appId?: string }): data is { appId: string } =>
    !!data.appId

const isRequestCatalogSearchServiceSearchEntitlementsPerAppRef = (
    data: RequestCatalogUserEntitlementPerAppValue | object,
): data is RequestCatalogUserEntitlementPerAppValue =>
    !!(data as RequestCatalogUserEntitlementPerAppValue).entitlement

const isRequestCatalogSearchServiceSearchBrowsableAppsInBundleRef = (
    data: BundleAppsWithCount | object,
): data is BundleAppsWithCount => !!(data as BundleAppsWithCount).app

const isConflictMonitorViewRef = (
    data: ConflictMonitorView | object,
): data is ConflictMonitorView => !!(data as ConflictMonitorView).monitor

const isAppEntitlementMonitorBindingRef = (
    data: AppEntitlementMonitorBindingView | object,
): data is AppEntitlementMonitorBindingView =>
    !!(data as AppEntitlementMonitorBindingView).ref

const isAncestorWithDescendants = (
    data: AncestorWithDescendants | object,
): data is AncestorWithDescendants => {
    return (
        (data as AncestorWithDescendants)?.ancestorEntitlement &&
        !!(data as AncestorWithDescendants).ancestorEntitlement.appId &&
        !!(data as AncestorWithDescendants).ancestorEntitlement.id
    )
}

const isOffboardingTrackerRef = (
    data: OffboardingTrackerView | object,
): data is OffboardingTrackerView =>
    !!(data as OffboardingTrackerView).offboardingTracker

const isConnectorRef = (data: ConnectorView | object): data is ConnectorView =>
    !!(data as ConnectorView).connector

const isAppEntitlementWithRequestCatalogsRef = (
    data: AppEntitlementWithRequestCatalogs | object,
): data is AppEntitlementWithRequestCatalogs =>
    !!(data as AppEntitlementWithRequestCatalogs).entitlement

const isAccessReviewTemplateOwnerRef = (
    data: AccessReviewTemplateServiceSearchOwnerView | object,
): data is AccessReviewTemplateServiceSearchOwnerView =>
    !!(data as AccessReviewTemplateServiceSearchOwnerView)

const isAccessReviewAppNavRollupRef = (
    data: AppRollup | object,
): data is AppRollup => !!(data as AppRollup)?.app?.app?.id

const isDirectoryRef = (data: DirectoryView | DirectoryValue | object): data is DirectoryView | DirectoryValue =>
    !!(data as DirectoryView).directory || !!(data as DirectoryValue).appId

const isUserAttributePushConfigurationRollup = (
    data: UserAttributePushConfigurationRollup | object,
): data is UserAttributePushConfigurationRollup =>
    !!(data as UserAttributePushConfigurationRollup).configuration

export const convertToRefString = (
    data: PartialMessage<object>,
    refTypeName?: string,
): string | null => {
    if (!refTypeName) return null

    switch (refTypeName) {
        case AccessReviewAppNavRollupRef.typeName:
            if (isAccessReviewAppNavRollupRef(data)) {
                return getRefString(
                    AccessReviewAppNavRollupRef.create({
                        appId: data.app?.app?.id,
                    }),
                )
            }
            return null
        case SessionSettings.typeName:
            // special case, tenant wide settings
            return SessionSettings.typeName
        case NotificationConfig.typeName:
            // special case, tenant wide settings
            return NotificationConfig.typeName
        case AncestralBindingRef.typeName:
            if (isAncestorWithDescendants(data)) {
                return getRefString(
                    AncestralBindingRef.create({
                        ancestorAppId: data.ancestorEntitlement.appId,
                        ancestorAppEntitlementId: data.ancestorEntitlement.id,
                    }),
                )
            }
            return null
        case ConflictMonitorRef.typeName:
            if (isConflictMonitorViewRef(data)) {
                return getRefString(
                    ConflictMonitorRef.create({ id: data.monitor?.id }),
                )
            }
            return getRefString(ConflictMonitorRef.create(data))
        case AppEntitlementMonitorBindingRef.typeName:
            return isAppEntitlementMonitorBindingRef(data)
                ? getRefString(AppEntitlementMonitorBindingRef.create(data.ref ?? {}))
                : null
        case RequestCatalogSearchServiceSearchEntitlementsPerAppRef.typeName:
            if (
                isRequestCatalogSearchServiceSearchEntitlementsPerAppRef(data)
            ) {
                return getRefString(
                    RequestCatalogSearchServiceSearchEntitlementsPerAppRef.create(
                        {
                            appId: data.entitlement?.appId || 'appId',
                            entitlementId:
                                data.entitlement?.id || 'appEntitlementId',
                        },
                    ),
                )
            }
            return null
        case RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef.typeName:
            if (
                isRequestCatalogSearchServiceSearchBrowsableAppsInBundleRef(
                    data,
                )
            ) {
                return getRefString(
                    RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef.create(
                        {
                            appId: data.app?.id || 'appId',
                        },
                    ),
                )
            }
            return null
        case OffboardingTrackerRef.typeName:
            return isOffboardingTrackerRef(data)
                ? getRefString(
                    OffboardingTrackerRef.create(data.offboardingTracker ?? {}),
                )
                : null
        case ConnectorRef.typeName:
            if (isConnectorRef(data)) {
                return getRefString(ConnectorRef.create(data.connector ?? {}))
            }
            return null
        case AppEntitlementWithRequestCatalogsRef.typeName:
            if (isAppEntitlementWithRequestCatalogsRef(data)) {
                return getRefString(
                    AppEntitlementWithRequestCatalogsRef.create({
                        appId: data.entitlement?.appId,
                        appEntitlementId: data.entitlement?.id,
                    }),
                )
            }
            return null
        case AccessReviewTemplateOwnerRef.typeName:
            if (isAccessReviewTemplateOwnerRef(data)) {
                return getRefString(
                    AccessReviewTemplateOwnerRef.create({
                        userId: data.user?.id,
                        accessReviewTemplateId: data.accessReviewTemplateId,
                    }),
                )
            }
            return null
        case DirectoryRef.typeName:
            if (isDirectoryRef(data)) {
                const appId = (data as DirectoryView).directory?.appId || (data as DirectoryValue).appId
                return getRefString(
                    DirectoryRef.create({
                        appId,
                    }),
                )
            }
            return null
        case UserAttributePushConfigurationRef.typeName:
            if (isUserAttributePushConfigurationRollup(data)) {
                return getRefString(
                    UserAttributePushConfigurationRef.create({
                        appId: data.configuration?.appId,
                        connectorId: data.configuration?.connectorId,
                    }),
                )
            }
            return getRefString(UserAttributePushConfigurationRef.create(data))
        // NOTE: Add only special cases here. Standard cases are already handled by just adding to the map.
        default: {
            const protoType = standardRefHandlers[refTypeName as keyof typeof standardRefHandlers]
            if (protoType) {
                return getRefString(protoType.create(data))
            }
            return null
        }
    }
}

export const convertRefStringToProto = (refString: string, refTypeName: string): AllowedRefs | null => {
    const ref = decodeRefString(refString) as Record<string, unknown>

    const protoType = standardRefHandlers[refTypeName as keyof typeof standardRefHandlers]
    if (protoType) {
        return protoType.create(ref) as AllowedRefs
    }

    return null
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getProtoTypeForTypeName = (refTypeName: string): MessageType<any> | null => {
    const protoType = standardRefHandlers[refTypeName as keyof typeof standardRefHandlers]
    if (protoType) {
        return protoType
    }

    console.error('Unsupported proto type:', refTypeName)
    return null
}

type DecodedRef = {
    tag: string;
    ref: AllowedRefs;
    eventType: ChangedRefEventType;
    lastUpdatedAt: Timestamp | undefined;
}
export class WebsocketNotifyClient {
    private static instance: WebsocketNotifyClient | undefined
    private readonly subscriptions: Record<
        string,
        Record<string, Array<OnNotifyEventType>>
    >

    private readonly events: Record<string, DecodedRef>
    private processEventsTimer: number | undefined = undefined
    private readonly authClient: OAuth2AuthCodePKCE

    constructor(authClient: OAuth2AuthCodePKCE) {
        this.subscriptions = {}
        this.events = {}
        this.authClient = authClient

        // Provide token getter to Hub so leader can open socket
        setGetAccessTokenProvider(async (): Promise<string | undefined> => {
            const at = await this.authClient.getAccessToken()
            return at.token?.value
        })

        // Subscribe to leader events - only if hub is available (client-side)
        const hub = getWsHub()
        hub?.subscribe(TOPIC_NOTIFY_CHANGED_RAW, (buf: ArrayBuffer) => {
            this.handleRawChanged(buf)
        })
    }

    public static getInstance(
        authClient: OAuth2AuthCodePKCE | undefined,
    ): WebsocketNotifyClient | undefined {
        if (!authClient) {
            return undefined
        }
        if (!WebsocketNotifyClient.instance) {
            WebsocketNotifyClient.instance = new WebsocketNotifyClient(
                authClient,
            )
        }
        return WebsocketNotifyClient.instance
    }

    private static decodeChanged(
        crProto: ChangedRef,
    ): Array<DecodedRef> | null {
        const { eventType, lastUpdatedAt } = crProto
        const changed = crProto.changed

        if (!changed) {
            return null
        }

        const getDecodedRef = <T extends object, S extends object>(
            ref: MessageType<T>,
            as?: MessageType<S>,
        ): DecodedRef => {
            const unpackedRef = Any.unpack<T>(changed, ref)

            if (
                as ===
                RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef &&
                hasAppId(unpackedRef)
            ) {
                // Special case so that we don't duplicate events over the wire for AEUBs, considering it can be a lot
                return {
                    tag: as.typeName,
                    ref: RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef.create(
                        {
                            appId: unpackedRef.appId,
                        },
                    ),
                    eventType,
                    lastUpdatedAt,
                }
            }

            if (as === AppRef && hasAppId(unpackedRef)) {
                return {
                    tag: as.typeName,
                    ref: AppRef.create({
                        id: unpackedRef.appId,
                    }),
                    eventType,
                    lastUpdatedAt,
                }
            }

            return {
                tag: ref.typeName,
                ref: unpackedRef,
                eventType,
                lastUpdatedAt,
            }
        }

        const typeName = Any.typeUrlToName(changed?.typeUrl || '')

        // Handle special cases that return multiple refs or have custom logic
        switch (typeName) {
            case AppOwnerRef.typeName:
                return [
                    getDecodedRef(AppOwnerRef),
                    getDecodedRef<AppOwnerRef, AppRef>(AppOwnerRef, AppRef),
                ]
            case AppEntitlementUserBindingRef.typeName:
                return [
                    getDecodedRef(AppEntitlementUserBindingRef),
                    getDecodedRef<
                        AppEntitlementUserBindingRef,
                        RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef
                    >(
                        AppEntitlementUserBindingRef,
                        RequestCatalogSearchServiceSearchBrowsableAppsInBundleRef,
                    ),
                ]
            // NOTE: Add only special cases here. Standard cases are already handled by just adding to the map.
            default: {
                // Handle standard cases
                const protoType = standardRefHandlers[typeName as keyof typeof standardRefHandlers]
                if (protoType) {
                    return [getDecodedRef(protoType)]
                }
                return null
            }
        }
    }

    private static getKey(tag: string, ref: AllowedRefs, eventType: ChangedRefEventType): string {
        return `${tag}🌮🌮${getRefString(ref)}🌮🌮${ChangedRefEventType[eventType]}`
    }

    private addEvent(k: string, decodedProto: DecodedRef): void {
        this.events[k] = decodedProto

        if (Object.keys(this.events).length >= 100) {
            this.processEvents()
        } else if (!this.processEventsTimer) {
            this.processEventsTimer = setInterval(() => {
                this.processEvents()
            }, processEventsDelay) as unknown as number
        }
    }

    private processEvents(): void {
        clearInterval(this.processEventsTimer)
        this.processEventsTimer = undefined
        for (const eventsKey in this.events) {
            this.processEvent(this.events[eventsKey])
            delete this.events[eventsKey]
        }
    }

    private processEvent(decodedProto: DecodedRef): void {
        const eventType = decodedProto.eventType
        const lastUpdatedAt = decodedProto.lastUpdatedAt
        if (!eventType) {
            return
        }

        const t = decodedProto.tag.toLowerCase()
        const subscription = this.subscriptions[t]
        if (!subscription) {
            return
        }

        Object.keys(subscription).forEach((k) => {
            subscription[k].forEach((handler) =>
                handler(decodedProto.ref, eventType, lastUpdatedAt))
        })
    }

    // Socket connection is leader-managed now. Followers receive ArrayBuffer and process here.
    private handleRawChanged = (buffer: ArrayBuffer): void => {
        const crProto = ChangedRef.fromBinary(new Uint8Array(buffer))
        const eventType = crProto.eventType
        const decoded = WebsocketNotifyClient.decodeChanged(crProto)

        if (!decoded || !eventType) return

        for (const item of decoded) {
            const k = WebsocketNotifyClient.getKey(item.tag, item.ref, eventType)
            if (
                !this.events[k] ||
                (this.events[k] && shouldProcess(this.events[k].lastUpdatedAt, crProto.lastUpdatedAt))
            ) {
                this.addEvent(k, item)
            }
        }
    }

    subscribe = (
        tags: string[],
        key: string,
        onNotify: OnNotifyEventType,
    ): void => {
        for (const tag of tags) {
            const t = tag.toLowerCase()
            if (!this.subscriptions[t]) {
                this.subscriptions[t] = {}
            }
            if (!this.subscriptions[t][key]) {
                this.subscriptions[t][key] = []
            }
            this.subscriptions[t][key].push(onNotify)
        }
    }

    unsubscribe = (tags: string[], key: string): void => {
        for (const tag of tags) {
            const s = this.subscriptions[tag.toLowerCase()]
            if (!s) {
                continue
            }
            delete s[key]
        }
    }
}
